import { KEYS } from "../keys";
import { register } from "./register";
import { ToolButton } from "../components/ToolButton";
import { DuplicateIcon } from "../components/icons";

export const actionChangeQuickFlow = register({
  name: "changeQuickFlow",
  trackEvent: { category: "element" },
  perform: (elements, appState, value) => {
    // console.log(value, "value");
    return {
      elements,
      appState: {
        ...appState,
        quickFlow: !appState.quickFlow,
      },
      commitToHistory: true,
    };
  },

  contextItemLabel: (elements, appState, app) => {
    return !appState.quickFlow
      ? "labels.enableQuickFlow"
      : "labels.disableQuickFlow";
  },
  keyTest: (event) => event[KEYS.CTRL_OR_CMD] && event.key === KEYS.D,
  PanelComponent: ({ elements, appState, updateData }) => {
    return (
      <ToolButton
        type="button"
        icon={DuplicateIcon}
        title={`changeQuickFlow`}
        aria-label={"changeQuickFlow"}
        onClick={() => updateData()}
      />
    );
  },
});
